class ConfigProvider
{
    /**
     * @param {String} key
     * @param defaultValue
     * @return {String|Number|null}
     */
    static get(key, defaultValue = null) {
        if (config.hasOwnProperty(key)) {
            return config[key];
        }

        return defaultValue;
    }
}

export {ConfigProvider};
